import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { IBalooGroup, IBalooMatch } from '@fi-app/external-platform-integration/baloo/baloo';
import { PkMatchType } from '@fi-app/external-platform-integration/pk/pk-match-type';
import { AppTextService } from '@fi-shared/app-text';
import { ObjectTypes } from '@fi-shared/types';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';

@Component({
    selector: 'fi-baloo-match-group-card',
    templateUrl: './baloo-match-group-card.component.html',
    styleUrls: ['./baloo-match-group-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-baloo-match-group-card' },
    standalone: false,
})
export class FiBalooMatchGroupCard {
    @Input() matches: IBalooMatch[] = [];
    @Input() allGroupMatches: IBalooMatch[] = [];
    @Input() matchType: PkMatchType;
    @Input() balooGroups: IBalooGroup[] = [];
    @Input() objectType: ObjectTypes;
    @Output() matchChange: EventEmitter<IBalooMatch> = new EventEmitter<IBalooMatch>();

    constructor(
        private appTextService: AppTextService,
        private fiCustomerDataService: FiCustomerDataService,
    ) {}

    getMatchListCardHeading(): string {
        return `${this.getMatchSectionLabelByType()} - ${this.matches.length} ${this.getObjectTypeLabel(
            this.matches.length > 1,
        )}`;
    }

    isNotMatchedSection(): boolean {
        return this.matchType === PkMatchType.NotMatched;
    }

    getMatchSectionLabelByType(): string {
        return this.appTextService.get(
            this.matchType === PkMatchType.NotMatched ? 'common.not_matched' : 'common.matched',
        );
    }

    getTableHeading(): string {
        return `${this.appTextService.get(
            this.objectType === ObjectTypes.Role ? 'common.roles' : 'common.units',
        )} ${this.appTextService.get('common.in')} ${this.fiCustomerDataService.customerData.DisplayName}`;
    }

    isBalooGroupDisabledFn(currentMatch: IBalooMatch, item: IBalooGroup, allItems: IBalooGroup[]): boolean {
        return !!this.allGroupMatches.find(
            (match: IBalooMatch) => match !== currentMatch && match.BalooId === item.GroupId,
        );
    }

    onMatchChange(match: IBalooMatch) {
        this.matchChange.emit(match);
    }

    private getObjectTypeLabel(isMultiple: boolean): string {
        if (this.objectType === ObjectTypes.Role)
            return this.appTextService.get(isMultiple ? 'common.roles' : 'common.role').toLowerCase();
        if (this.objectType === ObjectTypes.BusinessUnit)
            return this.appTextService.get(isMultiple ? 'common.units' : 'common.unit').toLowerCase();
    }
}
